import PageHero from "./PageHero";
import CtaBand from "./CtaBand";
import { CONTACT } from "../data";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { Reveal } from "./Reveal";
import { useSeo } from "../hooks/useSeo";

const INFO = [
  { icon: Phone, label: "Telefoon", value: CONTACT.phone, href: CONTACT.phoneHref },
  { icon: Mail, label: "E-mail", value: CONTACT.email, href: `mailto:${CONTACT.email}` },
  { icon: MapPin, label: "Adres", value: CONTACT.address, href: null },
  { icon: Clock, label: "Reactietijd", value: "Meestal dezelfde dag", href: null },
];

export const ContactPage = () => {
  useSeo({
    title: "Contact | SoftPro dak- en gevelreiniging",
    description:
      "Neem contact op met SoftPro voor een vrijblijvende offerte of persoonlijk advies over dak-, gevel- en terrasreiniging met softwash.",
  });

  return (
    <div data-testid="contact-page">
      <PageHero
        title="Neem contact op"
        subtitle="Vragen, een offerte aanvragen of gewoon nieuwsgierig hoe wij jouw woning of bedrijfspand kunnen laten stralen? We staan voor je klaar."
        image="https://images.pexels.com/photos/1535086/pexels-photo-1535086.jpeg?auto=compress&cs=tinysrgb&w=1920"
        crumb="Contact"
      />

      <section className="bg-background py-16">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10 grid grid-cols-2 lg:grid-cols-4 gap-5">
          {INFO.map((item, i) => {
            const inner = (
              <div className="h-full rounded-3xl border border-border bg-card p-6 transition-transform duration-300 hover:-translate-y-1">
                <span className="grid h-11 w-11 place-items-center rounded-2xl bg-teal/10 text-teal">
                  <item.icon className="h-5 w-5" />
                </span>
                <p className="mt-4 text-xs uppercase tracking-wide text-muted-foreground">
                  {item.label}
                </p>
                <p className="mt-1 font-semibold text-ink">{item.value}</p>
              </div>
            );
            return (
              <Reveal key={item.label} delay={i * 0.06}>
                {item.href ? <a href={item.href}>{inner}</a> : inner}
              </Reveal>
            );
          })}
        </div>
      </section>

      <CtaBand />
    </div>
  );
};

export default ContactPage;
